import { connect } from "react-redux";

import actions from "../../actions";
import ScheduleEditorEneosKawasaki from "../../components/list/ScheduleEditorEneosKawasaki";

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateItem: (data, handleSuccess, handleCancel) =>
      dispatch(actions.schedule_eneos_kawasaki.updateItem(data, handleSuccess, handleCancel)),
    setUnloadAlert: () => dispatch(actions.app.setUnloadAlert()),
    clearUnloadAlert: () => dispatch(actions.app.clearUnloadAlert()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleEditorEneosKawasaki);
